import React from "react";

const LOGO_URL = "/welljio-logo.png";

/**
 * Brand logo with responsive sizing.
 * `className` overrides default size classes.
 * `variant` "default" for dark surfaces, "light" inverts/whitens on dark backgrounds.
 */
export default function BrandLogo({ className = "", variant = "default", alt = "Welljio" }) {
  const isLight = variant === "light";
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={`${className || "h-8 sm:h-10 w-auto"} object-contain ${isLight ? "brightness-0 invert" : ""}`}
      loading="eager"
      decoding="async"
    />
  );
}
